export default __webpack_public_path__ + "static/media/homeSliderAgriculture.18019663.jpg";